// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red {
  color: var(--elem-red-color);
}
.color-green {
  color: green;
}
.color-blue {
  color: var(--toolbtn-active-color);
}
.publication-content {
  word-break: break-word;
}
.publication-content .inline-item {
  display: flex;
}
.publication-content .inline-item .publication-item > :first-child {
  width: 48px;
  text-align: center;
}
.publication-content .message-btn {
  width: 48px;
  min-width: 48px;
  height: 48px;
}
.publication-content .vertical-list > li:not(:last-child) {
  margin-bottom: 8px;
}
.publication-content .vertical-list .message-btn {
  margin: auto 0;
}
.publication-content .name-text {
  margin: auto 0 auto 5%;
  font-weight: bold;
  color: var(--font-color);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.publication-content .with-imgs-list {
  display: flex;
  align-items: center;
  overflow-y: auto;
}
.publication-content .with-imgs-list > li {
  position: relative;
  margin: 0 2px;
}
.publication-content .with-imgs-list > li:first-child {
  margin-left: 0;
}
.publication-content .with-imgs-list > li:last-child {
  margin-right: 0;
}
.publication-content .with-imgs-list .img-wrapper {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.publication-content .with-imgs-list .img-wrapper img {
  object-fit: contain;
  min-width: 100%;
}
.publication-content .with-imgs-list .img-wrapper .img-wrapper-slider {
  max-width: 720px;
  width: auto;
  object-fit: contain;
}
.publication-content .contacts-list,
.publication-content .geo-location-block {
  height: initial;
}
.publication-content .contacts-list .publication-item .name-text,
.publication-content .geo-location-block .publication-item .name-text {
  margin: auto 0;
  flex-grow: 1;
  padding: 10px;
}
.publication-content .poll-channel-block {
  width: 100%;
  padding: 0px 20px;
}
.publication-content .poll-channel-block .chat-poll-message {
  width: 100%;
  max-width: inherit;
}
.publication-content .contact-item,
.publication-content .audios-item,
.publication-content .file-item,
.publication-content .geo-location-item {
  display: flex;
  width: 90%;
  margin: auto auto auto 0;
}
.publication-content .geo-location-icon {
  margin: auto 0;
  color: #525252;
}
.publication-content .audios-item {
  display: flex;
  width: 90%;
}
.publication-content .audios-item .audio-middle-sections {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 70%;
}
.publication-content .audios-item .audio-middle-sections .top-audio-section > :first-child,
.publication-content .audios-item .audio-middle-sections .bottom-audio-section > :first-child {
  width: 80%;
  margin: 0 20px;
}
.publication-content .audios-item .audio-middle-sections .top-audio-section > :last-child,
.publication-content .audios-item .audio-middle-sections .bottom-audio-section > :last-child {
  width: 20%;
}
.publication-content .audios-item .audio-middle-sections .top-audio-section .slider,
.publication-content .audios-item .audio-middle-sections .bottom-audio-section .slider {
  width: 100%;
}
.publication-content .audios-item .audio-middle-sections .top-audio-section {
  display: flex;
  width: 100%;
}
.publication-content .audios-item .audio-middle-sections .top-audio-section .audio-time {
  text-align: right;
}
.publication-content .audios-item .audio-middle-sections .bottom-audio-section {
  display: flex;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./less/publications.less"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;;;;EAIE,aAAa;EACb,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":[".color-red {\n  color: var(--elem-red-color);\n}\n.color-green {\n  color: green;\n}\n.color-blue {\n  color: var(--toolbtn-active-color);\n}\n.publication-content {\n  word-break: break-word;\n}\n.publication-content .inline-item {\n  display: flex;\n}\n.publication-content .inline-item .publication-item > :first-child {\n  width: 48px;\n  text-align: center;\n}\n.publication-content .message-btn {\n  width: 48px;\n  min-width: 48px;\n  height: 48px;\n}\n.publication-content .vertical-list > li:not(:last-child) {\n  margin-bottom: 8px;\n}\n.publication-content .vertical-list .message-btn {\n  margin: auto 0;\n}\n.publication-content .name-text {\n  margin: auto 0 auto 5%;\n  font-weight: bold;\n  color: var(--font-color);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.publication-content .with-imgs-list {\n  display: flex;\n  align-items: center;\n  overflow-y: auto;\n}\n.publication-content .with-imgs-list > li {\n  position: relative;\n  margin: 0 2px;\n}\n.publication-content .with-imgs-list > li:first-child {\n  margin-left: 0;\n}\n.publication-content .with-imgs-list > li:last-child {\n  margin-right: 0;\n}\n.publication-content .with-imgs-list .img-wrapper {\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n}\n.publication-content .with-imgs-list .img-wrapper img {\n  object-fit: contain;\n  min-width: 100%;\n}\n.publication-content .with-imgs-list .img-wrapper .img-wrapper-slider {\n  max-width: 720px;\n  width: auto;\n  object-fit: contain;\n}\n.publication-content .contacts-list,\n.publication-content .geo-location-block {\n  height: initial;\n}\n.publication-content .contacts-list .publication-item .name-text,\n.publication-content .geo-location-block .publication-item .name-text {\n  margin: auto 0;\n  flex-grow: 1;\n  padding: 10px;\n}\n.publication-content .poll-channel-block {\n  width: 100%;\n  padding: 0px 20px;\n}\n.publication-content .poll-channel-block .chat-poll-message {\n  width: 100%;\n  max-width: inherit;\n}\n.publication-content .contact-item,\n.publication-content .audios-item,\n.publication-content .file-item,\n.publication-content .geo-location-item {\n  display: flex;\n  width: 90%;\n  margin: auto auto auto 0;\n}\n.publication-content .geo-location-icon {\n  margin: auto 0;\n  color: #525252;\n}\n.publication-content .audios-item {\n  display: flex;\n  width: 90%;\n}\n.publication-content .audios-item .audio-middle-sections {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  width: 70%;\n}\n.publication-content .audios-item .audio-middle-sections .top-audio-section > :first-child,\n.publication-content .audios-item .audio-middle-sections .bottom-audio-section > :first-child {\n  width: 80%;\n  margin: 0 20px;\n}\n.publication-content .audios-item .audio-middle-sections .top-audio-section > :last-child,\n.publication-content .audios-item .audio-middle-sections .bottom-audio-section > :last-child {\n  width: 20%;\n}\n.publication-content .audios-item .audio-middle-sections .top-audio-section .slider,\n.publication-content .audios-item .audio-middle-sections .bottom-audio-section .slider {\n  width: 100%;\n}\n.publication-content .audios-item .audio-middle-sections .top-audio-section {\n  display: flex;\n  width: 100%;\n}\n.publication-content .audios-item .audio-middle-sections .top-audio-section .audio-time {\n  text-align: right;\n}\n.publication-content .audios-item .audio-middle-sections .bottom-audio-section {\n  display: flex;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
